module.exports = __webpack_public_path__ + "static/educative-walkthrough-1ab587ddb36e52cf215015347f086cb9.mp4";